import { returnSlideArrayFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnLowerthirdsArrayFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnShowMetaDataFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnTimestampFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";

import { returnSlideArrayFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";
import { returnLowerthirdsArrayFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";
import { returnShowMetaDataFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";

import { parseMetaDictIntoDisplaySettings } from "@/models/utils/metaDictParse";

import { returnImageDirectoryFromMeta } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import each from "lodash/each";
import find from "lodash/find";

export class ZipShow {
  constructor(zip) {
    this.zip = zip;
    this.fileList = [];
    this.xmlFilePath = null;
    this.xmlString = null;
    this.txtFilePath = null;
    this.txtString = null;
    this.jsonFilePath = null;
    this.jsonString = null;
    this.error = false;
    this.errorMessage = null;
    this.slideArray = [];
    this.overlayArray = [];
    this.metaDict = {};
    this.imageDirectory = "";
    this.displaySettings = {};
    this.fileBlobUrls = {};
    this.blobsLoaded = false;
    this.audioBlob = null;
    this.audioFileObj = null;
    this.duration = null;
    this.info = null;
    this.autoTimeEnabled = false;
    this.autoTimePerImage = 4;

    this.ERROR_MISSING_AUDIO = "Audio file is missing from this zip.";
    this.ERROR_MISSING_IMAGE = "An image is missing from this zip.";
    this.ERROR_MISSING_CONTROL_FILE =
      "Missing Soundslides control file (xml or txt)";
  }

  populateFromXml() {
    // Create and return a show object based on the xml file.
    this.slideArray = returnSlideArrayFromXml(this.xmlString);
    this.overlayArray = returnLowerthirdsArrayFromXml(this.xmlString);
    this.metaDict = returnShowMetaDataFromXml(this.xmlString);
    this.imageDirectory = returnImageDirectoryFromMeta(this.metaDict);
    this.importMetaDictToDisplaySettings();
    this.populateInfo();
  }

  populateFromTxt() {
    // Create and return a show object based on the xml file.
    this.slideArray = returnSlideArrayFromTxt(this.txtString);
    this.overlayArray = returnLowerthirdsArrayFromTxt(this.txtString);
    this.metaDict = returnShowMetaDataFromTxt(this.txtString);
    this.imageDirectory = returnImageDirectoryFromMeta(this.metaDict);
    this.importMetaDictToDisplaySettings();
    this.populateInfo();
  }

  populateFromJson() {
    var data = JSON.parse(this.jsonString);
    console.log(data);
    this.slideArray = data.slideArray;
    this.overlayArray = data.overlayArray;
    this.displaySettings = data.displaySettings;
    this.info = {
      duration: data.audioFile.duration,
      slide_count: this.slideArray.length,
      title: data.title,
      dataType: "json",
      timestamp: data.publishedAt
    };
    this.autoTimeEnabled = data.autoTimeEnabled;
    this.autoTimePerImage = data.autoTimePerImage;
    this.imageDirectory = "assets";
  }

  populateInfo() {
    console.log(this.metaDict);
    this.info = {
      duration: this.duration,
      slide_count: this.slideArray.length,
      title: this.metaDict.header_headline
    };

    if (this.xmlString) {
      // Extract timestamp.
      this.info.timestamp = returnTimestampFromXml(this.xmlString);
      this.info.dataType = "xml";
    } else {
      this.info.timestamp = null;
      this.info.dataType = "txt";
    }

    if (this.metaDict.custom_size == "true") {
      this.info.width = parseInt(this.metaDict.custom_width, 10);
      this.info.height = parseInt(this.metaDict.custom_height, 10);
    } else {
      this.info.width = 600;
      this.info.height = 450;
    }
  }

  returnZipEntryImageName(filename) {
    var filenameWithPath = `${this.imageDirectory}/${filename}`;
    return find(this.fileList, f => {
      return f.endsWith(filenameWithPath) && !f.startsWith("__MACOSX");
    });
  }

  returnZipEntryAudioName(filename) {
    return find(this.fileList, f => {
      return f.endsWith(filename) && !f.startsWith("__MACOSX");
    });
  }

  extractFilesToBlobs() {
    var _zip = this.zip;
    var _this = this;
    var missingImage = false;
    // Images.
    var promises = [];

    each(this.slideArray, s => {
      var filename = this.returnZipEntryImageName(s.file);
      //console.log("filename", filename);
      if (!filename) {
        missingImage = true;
        return;
      }
      promises.push(
        _zip
          .file(filename)
          .async("blob")
          .then(blob => {
            var blobUrl = URL.createObjectURL(blob);
            return { file: s.file, blob: blob, blobUrl: blobUrl };
          })
      );
    });
    // Audio.
    var audioFilename = this.returnZipEntryAudioName("audio_hi.mp3");
    console.log("audioFilename", audioFilename);
    if (audioFilename) {
      // It's possible it is not in the zip.
      promises.push(
        _zip
          .file(audioFilename)
          .async("blob")
          .then(blob => {
            var blobUrl = URL.createObjectURL(blob);
            _this.audioBlob = blobUrl;
            _this.audioFileObj = blob;
            return { file: "audio_hi.mp3", blob: blob, blobUrl: blobUrl };
          })
      );
    } else {
      // Is this show supposed to have audio?
      if (_this.metaDict.slide_only) {
        // Let it pass. It's cool.
      } else {
        _this.error = true;
        _this.errorMessage = _this.ERROR_MISSING_AUDIO;
      }
    }
    return Promise.all(promises).then(blobs => {
      //console.log("blobs", blobs);
      // Add image blob urls to fileBlobUrls
      each(blobs, s => {
        console.log(s.file);
        console.log(s.blobUrl);
        _this.fileBlobUrls[s.file] = s.blobUrl;
      });
      // Save the fileObjects for later.
      var fileObjects = {};
      each(blobs, s => {
        fileObjects[s.file] = s.blob;
      });

      _this.blobsLoaded = true;
      if (missingImage) {
        _this.error = true;
        _this.errorMessage = _this.ERROR_MISSING_IMAGE;
      }
      // Populate slideArray with blob properties.
      each(_this.slideArray, s => {
        s.blob = _this.fileBlobUrls[s.file];

        s.fileObj = fileObjects[s.file];
      });
      return _this;
    });
  }

  async parseZip() {
    var _this = this;
    var _zip = this.zip;
    // Get all the file entries.
    _zip.forEach(function(relativePath, zipEntry) {
      // 2) print entries
      console.log(relativePath);
      if (!zipEntry.name.startsWith("__MACOSX")) {
        // Do not add odd __MACOSX files.
        _this.fileList.push(zipEntry.name);
      }

      // Find the xml or txt control file.
      if (
        zipEntry.name.endsWith("soundslide.xml") &&
        !zipEntry.name.startsWith("__MACOSX")
      ) {
        _this.xmlFilePath = zipEntry.name;
      }

      if (
        zipEntry.name.endsWith("soundslide.txt") &&
        !zipEntry.name.startsWith("__MACOSX")
      ) {
        _this.txtFilePath = zipEntry.name;
      }

      // Look for the json path.
      if (
        zipEntry.name.endsWith("data.json") &&
        !zipEntry.name.startsWith("__MACOSX")
      ) {
        _this.jsonFilePath = zipEntry.name;
      }
    });

    // Read the xml.

    if (_this.xmlFilePath) {
      return await new Promise((resolve, reject) => {
        _zip
          .file(_this.xmlFilePath)
          .async("string")
          .then(text => {
            _this.xmlString = text;
            _this.populateFromXml();
            resolve(_this);
          })
          .catch(e => {
            console.log(e);
            reject(_this);
          });
      });
    } else if (_this.txtFilePath) {
      return await new Promise((resolve, reject) => {
        _zip
          .file(_this.txtFilePath)
          .async("string")
          .then(text => {
            _this.txtString = text;
            _this.populateFromTxt();
            resolve(_this);
          })
          .catch(e => {
            console.log(e);
            reject(_this);
          });
      });
    } else if (_this.jsonFilePath) {
      return await new Promise((resolve, reject) => {
        _zip
          .file(_this.jsonFilePath)
          .async("string")
          .then(text => {
            _this.jsonString = text;
            _this.populateFromJson();
            resolve(_this);
          })
          .catch(e => {
            console.log(e);
            reject(_this);
          });
      });
    } else {
      // Neither txt or xml.
      _this.error = true;
      _this.errorMessage = _this.ERROR_MISSING_CONTROL_FILE;
      return _this;
    }
  }

  importMetaDictToDisplaySettings() {
    this.displaySettings = parseMetaDictIntoDisplaySettings(
      this.metaDict,
      this.displaySettings
    );
    this.duration = this.displaySettings.duration;
    console.log("displaySettings", this.displaySettings);
  }
}
